import React from 'react'

function Footer() {
    return (
        <>
            <div className='layout bg-white py-6 md:py-8'>
                <div className='flex justify-start items-center'>
                    <div>
                        <span className='font-sans text-sm md:text-base font-medium text-gray-600'>Copyright ©2022 Gitbash. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer